// ScrollToTarget usage:
// const this.scroll = new scrollToTarget();
// this.scroll.scrollTo(destination, duration = 200, easing = 'linear', posAdjust = 0, callback)
// "destination" : Could be a Number or a Dom Element
// "duration"    : Duration of scrolling
// "easing"      : 'linear', 'easeInOutQuad' and so on....
// "posAdjust"   : Add or substract some Pixels to the destinationOffset
// "callback"    : If scrolling is done call callback
//

'use strict';

class scrollToTarget {
    constructor () {
        this.easing = {
            linear (t) {
                return t;
            },
            easeInQuad (t) {
                return t * t;
            },
            easeOutQuad (t) {
                return t * (2 - t);
            },
            easeInOutQuad (t) {
                return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
            },
            easeInCubic (t) {
                return t * t * t;
            },
            easeOutCubic (t) {
                return (--t) * t * t + 1;
            },
            easeInOutCubic (t) {
                return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
            },
            easeInQuart (t) {
                return t * t * t * t;
            },
            easeOutQuart (t) {
                return 1 - (--t) * t * t * t;
            },
            easeInOutQuart (t) {
                return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
            },
            easeInQuint (t) {
                return t * t * t * t * t;
            },
            easeOutQuint (t) {
                return 1 + (--t) * t * t * t * t;
            },
            easeInOutQuint (t) {
                return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
            }
        };
    }

    scrollTo (destination, duration = 200, easing = 'easeOutQuad', posAdjust = 0, callback) {
        const start = window.pageYOffset;
        const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

        const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
        const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
        let destinationOffset = typeof destination === 'number' ? destination : this.getPosition(destination).y + posAdjust;
        destinationOffset = destinationOffset < 0 ? 0 : destinationOffset;

        const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);

        if (!('requestAnimationFrame' in window)) {
            window.scroll(0, destinationOffsetToScroll);

            if (callback) {
                callback();
            }
            return;
        }

        const scroll = () => {
            const now = 'now' in window.performance ? performance.now() : new Date().getTime();
            const time = Math.min(1, ((now - startTime) / duration));
            const timeFunction = this.easing[easing](time);
            window.scroll(0, Math.round((timeFunction * (destinationOffsetToScroll - start)) + start));

            if (Math.round(window.pageYOffset) === destinationOffsetToScroll) {
                if (callback) {
                    callback();
                }
                return;
            }

            requestAnimationFrame(scroll);
        };

        scroll();
    }

    getPosition (el) {
        let x = 0;
        let y = 0;

        while (el != null && (el.tagName || '').toLowerCase() !== 'html') {
            x += el.offsetLeft || 0;
            y += el.offsetTop || 0;
            el = el.parentElement;
        }
        return { x: parseInt(x, 10), y: parseInt(y, 10) };
    }
}

export default scrollToTarget;
